import _Promise from "babel-runtime/core-js/promise";
import _regeneratorRuntime from "babel-runtime/regenerator";
import _Object$assign from "babel-runtime/core-js/object/assign";
import _asyncToGenerator from "babel-runtime/helpers/asyncToGenerator";


import bizPublicSaveMethod from "@/business/businessTools/bizPublicSaveMethod.js";
import tools from "../../QS420/QS420_tools";

var GROUP_ID = "";

var MODULE_ID = "";

var SAVE_PATH = "";
var SAVE_PATH2 = "";

var backfillHistoryData = function backfillHistoryData(_this) {
  var keyInfo = _.cloneDeepGet(_this.historyData, SAVE_PATH);
  if (!_.isEmpty(keyInfo)) {
    ["CUST_FNAME", "CUST_NAME", "ID_TYPE", "ID_CODE"].forEach(function (item) {
      keyInfo[item] = keyInfo["NEW_" + item];
      keyInfo[item + "_DATA_SOURCE"] = keyInfo["NEW_" + item + "_DATA_SOURCE"];
    });
    _this.$blMethod.parseGroupsMouduleData(_this, [MODULE_ID], keyInfo);
    _this.$blMethod.parseGroupsMouduleDataSource(_this, [MODULE_ID], keyInfo);
  }
};

var initFieldConfig = function initFieldConfig(_this) {
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;
  fields.CUSTOMER_TYPE.FIELD_DICT_NAME = [{ DICT_ITEM: "0", DICT_ITEM_NAME: "管理人" }, { DICT_ITEM: "1", DICT_ITEM_NAME: "托管人" }];
  fields.ID_CODE.FIELD_FUNCTION = fields.ID_CODE.FIELD_FUNCTION.replace(/\|GET_PRO_CACHE/g, "") + "|GET_PRO_CACHE";
  fields.ID_TYPE.FIELD_DICT_NAME = _.filter(fields.ID_TYPE.FIELD_DICT_NAME, function (item) {
    return _this.oppBusiData.EFFECT_ID_TYPE.includes(item.DICT_ITEM) && item.DICT_ITEM[0] == "1";
  });
  fields.CUST_FNAME.VALID_TYPE = "valAX[0,128]|on-blur";
  fields.CUST_NAME.VALID_TYPE = "valAX[4,16]|on-blur";
  fields.CUSTOMER_TYPE.DEFAULT_VALUE = "0";
};

var update = function update(_this) {
  var module = _this.groupDatas[GROUP_ID][MODULE_ID][0];
  var fields = _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS;

  var _loop = function _loop(key) {
    var funcArr = _.get(fields[key], "FIELD_FUNCTION", "").split("|");
    _.each(funcArr || [], function (func) {
      NODE[func] && NODE[func](_this, fields[key], fields, module);
    });
  };

  for (var key in fields) {
    _loop(key);
  }
};

var NODE = {
  getGroupId: function getGroupId() {
    return GROUP_ID;
  },

  getModuleId: function getModuleId() {
    return MODULE_ID;
  },

  init: function init(_this) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    GROUP_ID = params.groupId;
    MODULE_ID = params.moduleId;
    SAVE_PATH = params.savePath;
    SAVE_PATH2 = params.savePath2;
  },

  beforeLoadBiz: function beforeLoadBiz(_this) {
    initFieldConfig(_this);
  },

  afterLoadBiz: function afterLoadBiz(_this) {
    backfillHistoryData(_this);
  },

  beforeSave: function () {
    var _ref = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(_this, params) {
      var fields, keyInfo, customerInfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              fields = bizPublicSaveMethod.getModuleObjctFoyKey(_this, MODULE_ID, [SAVE_PATH, SAVE_PATH2]);
              keyInfo = {
                NEW_CUST_FNAME: fields.CUST_FNAME,
                NEW_CUST_FNAME_DATA_SOURCE: fields.CUST_FNAME_DATA_SOURCE,
                NEW_CUST_NAME: fields.CUST_NAME,
                NEW_CUST_NAME_DATA_SOURCE: fields.CUST_NAME_DATA_SOURCE,
                NEW_ID_TYPE: fields.ID_TYPE,
                NEW_ID_TYPE_DATA_SOURCE: fields.ID_TYPE_DATA_SOURCE,
                NEW_ID_CODE: fields.ID_CODE,
                NEW_ID_CODE_DATA_SOURCE: fields.ID_CODE_DATA_SOURCE,
                CUSTOMER_TYPE: fields.CUSTOMER_TYPE,
                CUSTOMER_TYPE_DATA_SOURCE: fields.CUSTOMER_TYPE_DATA_SOURCE
              };
              customerInfo = _this.$storage.getJsonSession(_this.$definecfg.CUSTOMER_INFO) || {};

              _Object$assign(customerInfo, {
                CUST_FNAME: keyInfo.NEW_CUST_FNAME,
                CUST_NAME: keyInfo.NEW_CUST_NAME,
                ID_TYPE: keyInfo.NEW_ID_TYPE,
                ID_CODE: keyInfo.NEW_ID_CODE,
                USER_TYPE: "2"
              });
              _this.$store.commit(_this.$types.UPDATE_CUSTOMER_INFO, customerInfo);

              bizPublicSaveMethod.getModuleUpdateFlagByPaths(_this, [SAVE_PATH], keyInfo);

              _.set(params, SAVE_PATH, _Object$assign({}, _.get(params, SAVE_PATH, {}), keyInfo));

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    function beforeSave(_x2, _x3) {
      return _ref.apply(this, arguments);
    }

    return beforeSave;
  }(),
  validate: function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(_this) {
      var data, res;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              data = {
                ID_CODE: _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.ID_CODE.DEFAULT_VALUE,
                CUST_FNAME: _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.CUST_FNAME.DEFAULT_VALUE,
                ID_TYPE: _this.groupDatas[GROUP_ID][MODULE_ID][0].FIELDS.ID_TYPE.DEFAULT_VALUE,
                USER_TYPE: _this.userType
              };

              _this.$store.commit(_this.$types.UPDATE_LOADING, "正在进行反洗钱查询...");
              _context2.next = 4;
              return _this.$syscfg.K_Request("F0000062", data);

            case 4:
              res = _context2.sent;

              if (!(res.Code == 0)) {
                _context2.next = 10;
                break;
              }

              if (!(res.Data[0] && res.Data[0].AML_LVL == 9)) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", new _Promise(function (resolve, reject) {
                _this.alert("系统检测到您的账户存在风险，请您临柜开户！");
                resolve(false);
              }).then(function (res) {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                return res;
              }).finally(function () {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
              }));

            case 8:
              _context2.next = 11;
              break;

            case 10:
              return _context2.abrupt("return", new _Promise(function (resolve, reject) {
                _this.alert("反洗钱查询失败, 请稍后重试!");
                resolve(false);
              }).then(function (res) {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
                return res;
              }).finally(function () {
                _this.$store.commit(_this.$types.UPDATE_LOADING, false);
              }));

            case 11:
              return _context2.abrupt("return", true);

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, this);
    }));

    function validate(_x4) {
      return _ref2.apply(this, arguments);
    }

    return validate;
  }(),
  update: update
};

export default NODE;


//////////////////
// WEBPACK FOOTER
// ./src/business/businessFile/QS421/bizPro/bizProImportantInfo.js
// module id = 208
// module chunks = 2